import React, { useState, useEffect } from 'react';
import './HeroSection.css';

function HeroSection() {
    const [typedText, setTypedText] = useState('');
    const textContent = "Weapon Recognition System";

    useEffect(() => {
        let i = 0;
        const intervalId = setInterval(() => {
            if (i < textContent.length) {
                setTypedText(prevTypedText => prevTypedText + textContent.charAt(i));
                i++;
            } else {
                clearInterval(intervalId);
                startTyping(); // Restart the animation immediately
            }
        }, 100); // Speed of typing (milliseconds)

        return () => clearInterval(intervalId); // Clean up on component unmount
    }, []); // Empty dependency array to run only once on mount

    const startTyping = () => {
        //setTypedText(''); // Clear the text immediately after typing it
    };

    const handleDetectionClick = () => {
        // Open the link in a new tab/window
        window.open('http://127.0.0.1:5000/video_feed', '_blank');
    };

    return (
        <section className="hero">
            <h2><span className="typewriter">{typedText}</span></h2>
            <div>
                <br />
                <p>Ensuring safety and security with advanced AI technology.</p>
            </div>
            {/* Add Detection button below the text */}
            <button className="detection-button" onClick={handleDetectionClick}>
                Live Recognition
            </button>
        </section>
    );
}

export default HeroSection;
